// extracted by mini-css-extract-plugin
module.exports = {"row":"CreateHandbookTemplate_row__1QBJx","addButton":"CreateHandbookTemplate_addButton__12YtK"};